<template>
	<div class="animated fadeIn">
		<b-card>
			<b-card-header>
				<i class="icon-menu mr-1"></i>裝置列表
				<div class="card-header-actions">
					<b-link @click="openEditor()" v-if="!cannotEdit"><i class="fa fa-plus"></i> 新增</b-link>&nbsp;
					<b-link @click="SysReboot()" v-if="!cannotEdit"><i class="fa fa-power-off"></i> 系統重啟</b-link>
				</div>
			</b-card-header>
		  <b-card-body>
			<v-server-table :columns="columns" :data="data" :options="options" :theme="theme" ref="dataTable" id="dataTable">
				<a slot="end_user_id" slot-scope="props">{{props.row.EndUser ? props.row.EndUser.name : '未連結'}}</a>
				<a slot="device_activated" slot-scope="props" class="d-inline-block text-center w-100"><span :id="'PHolder'+props.row.sn"><i class="fa fa-question-circle"></i></span></a>
				<a slot="test" slot-scope="props" class="d-inline-block text-center w-100"><span :id="'THolder'+props.row.sn"></span></a>
				<a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
				<a slot="brand_id" slot-scope="props">{{props.row.ChargerBrand?props.row.ChargerBrand.name:'N/A'}}</a>
				<!--<a slot="charge_first" class="text-center" slot-scope="props">{{props.row.charge_first?`Y($${props.row.charge_value})`:''}}</a>-->
				<a slot="billing_method" class="text-center" slot-scope="props">{{props.row.billing_method}}</a>
				<a slot="remoteable" class="text-center" slot-scope="props">{{props.row.remoteable?`Y`:''}}</a>
				<!--<a slot="plug_and_charge" class="text-center" slot-scope="props">{{props.row.plug_and_charge?`Y`:''}}</a>
				<a slot="rfid_charge" class="text-center" slot-scope="props">{{props.row.rfid_charge?`Y`:''}}</a>-->
				<a slot="schedulable" class="text-center" slot-scope="props">{{props.row.schedulable?`Y`:''}}</a>
				<a slot="idle_fee" class="text-center" slot-scope="props">{{props.row.idle_fee?`Y`:''}}</a>
				<a slot="created" slot-scope="props"><span :id="'PCHolder'+props.row.id"><i class="fa fa-question-circle"></i></span></a>

				<div slot="child_row" slot-scope="props">
					<b-button variant="info" class="btn-pill" size="sm" v-if="!cannotEdit" @click="editRow(props.row.id, props.row)"><i class="fa fa-pencil"></i> 編輯</b-button> &nbsp;
					<b-button variant="danger" class="btn-pill" size="sm" v-if="!cannotEdit" @click="delRow(props.row.id, props.row.name)"><i class="fa fa-times"></i> 刪除</b-button> &nbsp;
					<b-button variant="success" class="btn-pill" size="sm" @click="genRow(props.row.sn)"><i class="fa fa-qrcode"></i> QRCode</b-button> &nbsp;
					<b-button variant="warning" class="btn-pill" size="sm" @click="openLog(props.row)"><i class="fa fa-list"></i> 紀錄</b-button> &nbsp;
					<b-button  v-if="!cannotEdit && isCharging(props.row.id)" variant="secondary" class="btn-pill" size="sm" @click="forceCheckout(props.row.sn)"><i class="fa fa-power-off"></i> 強制結帳</b-button> &nbsp;
					<b-button  v-if="!cannotEdit" variant="secondary" class="btn-pill" size="sm" @click="DevReboot(props.row.sn)"><i class="fa fa-power-off"></i> 重啟</b-button> &nbsp;
					<!-- <b-button class="btn-pill" size="sm" @click="genRow(props.row.sn, 'test')"><i class="fa fa-wrench"></i> 測試</b-button> &nbsp; -->
				</div>
			</v-server-table>
		  </b-card-body>
		</b-card>

		<b-modal title="刪除裝置" size="sm" v-model="delRowShowModal" @ok="submitDelRow(delRowId)" ok-title="確定" cancel-title="取消">
	   {{delRowMsg}}
	 </b-modal>

	    <b-modal title="裝置QR Code" v-model="showQrCode" ok-title="確定" cancel-title="取消">
	    	<div class="w-100 text-center">
	      		<img id="qrcode-canvas">
	      		<p class="text-muted">存取裝置的QR Code</p>
	      		<p class="text-primary"><a :href="device_uri" target="_blank">URI</a></p>
	  		</div>
	    </b-modal>

	    <b-modal title="裝置充電紀錄" v-model="showLogList" ok-title="確定" :ok-only="true" size="xl" >
	    	<v-server-table :columns="logcolumns" :data="logdata" :options="logoptions" :theme="theme" ref="logDataTable" id="logDataTable">
				<a slot="user_id" slot-scope="props">{{props.row.EndUser ? props.row.EndUser.name : '未連結'}}</a>
				<a slot="phone" slot-scope="props">{{props.row.EndUser ? props.row.EndUser.phone : '未提供'}}</a>
				<a slot="company_id" slot-scope="props">{{props.row.Company?props.row.Company.name:'N/A'}}</a>
				<a slot="start_time" slot-scope="props">{{props.row.start_time|htime}}</a>
				<a slot="stop_time" slot-scope="props">{{props.row.stop_time|htime}}</a>
				<a slot="end_time" slot-scope="props">{{props.row.end_time|htime}}</a>
				<a slot="billing_method" slot-scope="props">{{props.row.billing_method === 'TIME' ? '時間' : '度數'}}</a>
				<a slot="created" slot-scope="props">{{props.row.created.substring(0, 16)}}</a>
				<a slot="used_value" slot-scope="props">{{get_used_value(props.row)}}</a>
				<a slot="price" slot-scope="props">{{props.row.price}}/{{props.row.price_peak}}{{props.row.billing_method === 'TIME' ? '點/分鐘' : '點/度'}}</a>
				<a slot="used_time_idle" slot-scope="props">{{props.row.stop_time > 0 ? get_real_used_time_idle(props.row) : 'N/A'}}</a>
        		<a slot="price_idle" slot-scope="props">{{props.row.stop_time > 0 ? $math.round(props.row.price_idle, 2) + '點(' + props.row.idle_info + ')': 'N/A'}}</a>
			</v-server-table>
	    </b-modal>

	    <b-modal title="編輯器" size="lg" class="modal-info" v-model="showEditorModal" :no-enforce-focus="true" @ok="submitRecord" ok-title="儲存" cancel-title="取消" :ok-disabled="$v.$invalid">
	        <b-form>
              <h1>裝置資料</h1>
              <p class="text-muted">綠框為必填</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-clone"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="名稱" 
                              v-model.lazy.trim="$v.record.name.$model"
                              v-focus
                              :state="chkState('name')"
                              aria-describedby="invalidNameFeedback"/>
                <b-form-invalid-feedback id="invalidNameFeedback">名稱必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-code"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="序號" 
                              v-model.lazy.trim="$v.record.serialno.$model"
                              :state="chkState('serialno')"
                              aria-describedby="invalidSnFeedback"/>
                <b-form-invalid-feedback id="invalidSnFeedback">序號必填</b-form-invalid-feedback>
              </b-input-group>

			  <b-input-group class="mb-3">
				<b-input-group-prepend>
					<b-input-group-text><i class="fa fa-bolt"></i></b-input-group-text>
				</b-input-group-prepend>
				<!-- star-id_meter-id -->
				<b-form-input
					type="text"
					class="form-control"
					placeholder="電表ID(非必要)"
					v-model.lazy.trim="$v.record.meter_id.$model"
					:state="$v.record.meter_id.$dirty ? $v.record.meter_id.validFormat : null"
					maxlength="30"
					aria-describedby="invalidMeterIdFeedback"/>
				<b-form-invalid-feedback id="invalidMeterIdFeedback">格式為:<strong>StarId</strong>_<strong>MeterId</strong></b-form-invalid-feedback>
			  </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-globe"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="device-company-id"
                              class="form-control hidden" 
                              placeholder="*Company" 
                              v-model.lazy.trim="$v.record.company_id.$model"
                              v-focus
                              :state="chkState('company_id')"
                              aria-describedby="invalidCNFeedback"/>
                <b-form-invalid-feedback id="invalidCNFeedback">必填</b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="icon-diamond icon"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="device-end_user_id"
                			  type="text" 
                              class="form-control hidden w-12" 
                              placeholder="擁有人ID" 
                              v-model.lazy.trim="$v.record.end_user_id.$model"
                              :state="chkState('end_user_id')"
                              aria-describedby="invalidEUIDFeedback"/>
                <b-form-invalid-feedback id="invalidEUIDFeedback">ID必須為比1大的數字</b-form-invalid-feedback>
              </b-input-group>
              
              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-map-marker"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="地理位置" 
                              v-model.lazy.trim="record.geo_location"/>
              </b-input-group>

			  <b-input-group class="mb-3">
                <b-input-group-prepend>
                	<b-input-group-text><i class="cui-globe"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select id="device-brand-id"
                              class="form-control hidden" 
                              placeholder="充電樁廠牌" 
                              v-model.lazy.trim="$v.record.brand_id.$model"
							  :state="chkState('brand_id')"
                              aria-describedby="invalidEUIDFeedback"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-cc"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="廠牌" 
                              v-model.lazy.trim="record.brand"/>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-cc"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="所在樓層" 
                              v-model.lazy.trim="record.floor"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-globe"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="LAT" 
                              v-model.lazy.trim="record.lat"/>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="LNG" 
                              v-model.lazy.trim="record.lng"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="icon-call-out icons"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="MQTT-PUSH" 
                              v-model.lazy.trim="record.mqtt_push"/>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="icon-call-in icons"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="text" 
                              class="form-control" 
                              placeholder="MQTT-PULL" 
                              v-model.lazy.trim="record.mqtt_pull"/>
              </b-input-group>
			 
			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-usd"></i> 計費方式</b-input-group-text>
                </b-input-group-prepend>
				<v-select v-model="edit_billing_method" :options="billing_method_options" placeholder="請選擇計費方式"></v-select>
              </b-input-group>
              
              <b-input-group class="mb-4" v-if="!hide_demo_option">
                <b-input-group-prepend>
                	<b-input-group-text><i class="fa fa-users"></i> DEMO用裝置</b-input-group-text>
                </b-input-group-prepend>
                <v-select v-model="record.demo" :options="demo_options" placeholder="是否為DEMO用裝置"></v-select>
                <span class="text-primary help-text">DEMO用裝置必須指派一名擁有者，否則無效</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-handshake-o"></i> 允許遠端控制</b-input-group-text>
                </b-input-group-prepend>
				<v-select v-model="edit_remoteable" :options="remoteable_options" placeholder="是否允許遠端控制"></v-select>
                <span class="text-primary help-text">若為"YES"，則允許遠端控制</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-plug"></i> 支援隨插即充</b-input-group-text>
                </b-input-group-prepend>
				<v-select v-model="edit_plug_and_charge" :options="plug_and_charge_options" placeholder="是否支援隨插即充"></v-select>
                <span class="text-primary help-text">若為"YES"，則支援隨插即充</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-feed"></i> 支援感應卡</b-input-group-text>
                </b-input-group-prepend>
				<v-select v-model="edit_rfid_charge" :options="rfid_charge_options" placeholder="是否支援感應卡"></v-select>
                <span class="text-primary help-text">若為"YES"，則支援感應卡</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-clock-o"></i> 支援排程充電</b-input-group-text>
                </b-input-group-prepend>
				<v-select v-model="edit_schedulable" :options="schedulable_options" placeholder="是否支援排程充電"></v-select>
                <span class="text-primary help-text">若為"YES"，則支援排程充電</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-usd"></i> 開啟佔位收費</b-input-group-text>
                </b-input-group-prepend>
				<v-select v-model="edit_idle_fee" :options="idle_fee_options" placeholder="是否開啟佔位收費"></v-select>
                <span class="text-primary help-text">若為"YES"，則開啟佔位收費</span>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-commenting-o"></i> 開啟離線通知</b-input-group-text>
                </b-input-group-prepend>
                <v-select v-model="edit_to_monit" :options="to_monit_options" placeholder="是否開啟離線通知"></v-select>
                <span class="text-primary help-text">若為"YES"，則開啟離線通知</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-clock-o"></i> 低瓦偵測值</b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="number" 
                              class="form-control" 
                              placeholder="請輸入數值" 
                              v-model.lazy.trim="record.low_power_cutoff_threshold"/>
                <span class="text-primary help-text">單位:Watt。</span>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-clock-o"></i> 進充等待時間</b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="number" 
                              class="form-control" 
                              placeholder="請輸入數值" 
                              v-model.lazy.trim="record.charging_timeout"/>
                <span class="text-primary help-text">單位:秒。</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-clock-o"></i> 進充後低瓦偵測時間</b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="number" 
                              class="form-control" 
                              placeholder="請輸入數值" 
                              v-model.lazy.trim="record.low_power_charging_timeout"/>
                <span class="text-primary help-text">單位:秒。數值夠大可使狀態SUSPENDED_EV回到CHARGING</span>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-clock-o"></i> 每日充電上限</b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="number"
                              class="form-control" 
                              placeholder="請輸入數值" 
                              v-model.lazy.trim="record.charging_time_limit_minutes"/>
                <span class="text-primary help-text">單位:分鐘。預設為2880，小於2880則啟用</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-clock-o"></i> 溫度上限</b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="number"
                              class="form-control" 
                              placeholder="請輸入數值" 
                              v-model.lazy.trim="record.temperature_cutoff_celsius"/>
                <span class="text-primary help-text">單位:度。</span>
              </b-input-group>

			  <b-card class="no-padding" header="支援車廠優惠">
				<div class="checkbox-container">
					<b-form-checkbox v-model="isChecked_PORSCHE">PORSCHE</b-form-checkbox>
					<b-form-checkbox v-model="isChecked_BMW">BMW</b-form-checkbox>
				</div>
			  </b-card>

			  <b-card no-body>
				<div slot="header">
				  <i class="fa fa-clock-o"></i> 開放時間設定&nbsp;
				  <b-button style="margin: 0 3px; color: white;" class="pull-right" size="sm" variant="success" @click="popOpenTimeEditModal(null)"><i class="fa fa-plus"></i></b-button>&nbsp;
				</div>
				<b-card-body ref="open_time_ref">
				  <div v-for="(open_time, index) in available_open_times" :key="open_time.id">
					<b-card v-if="!open_time.delete" no-body>
					  <div slot="footer" class="text-center">
						<b-button style="margin: 0 3px; color: white;" size="sm" variant="primary" @click="popOpenTimeEditModal(open_time)"><i class="fa fa-calendar"></i> 修改</b-button>
						<b-button style="margin: 0 3px; color: white;" size="sm" variant="danger" @click="OpenTimeRemove(open_time)"><i class="fa fa-times"></i> 刪除</b-button>&nbsp;
					  </div>
					  <b-card-body>
						<div style="font-size: 2rem; font-weight: bold;">
						  {{open_time.start_time + '~' + open_time.end_time}}
						</div>
						<div>
						  {{ getWeeklyInfo(open_time.weekly) }}
						</div>
						<div v-if="open_time.holiday_close">國定假日不開放</div>
					  </b-card-body>
					</b-card >
				  </div>
				</b-card-body>
			  </b-card >
			  

              <!--<b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-usd"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="number" 
                              class="form-control" 
                              placeholder="顯示價格" 
                              v-model.lazy.trim="record.price"
                              min="0"/>
                <span class="text-primary help-text">此價格若大於0將會顯示在前端充電頁面</span>
              </b-input-group>

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-usd"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-select placeholder="是否為預先收款裝置" 
                          :options="charge_first_options"
                          v-model="record.charge_first"></b-form-select>
                <span class="text-primary help-text">若為"是"，則使用者點擊開始充電時會預先收款</span>
              </b-input-group>

			  <b-input-group class="mb-4">
                <b-input-group-prepend>
                  <b-input-group-text><i class="fa fa-usd"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="number" 
                              class="form-control" 
                              placeholder="預先收款金額" 
                              v-model.lazy.trim="record.charge_value"
                              min="0"/>
                <span class="text-primary help-text">設定預先收款金額</span>
              </b-input-group>-->

              <b-input-group class="mb-4">
                <b-input-group-prepend>
                	<b-input-group-text><i class="icon-notebook icon"></i></b-input-group-text>
                </b-input-group-prepend>
                <b-form-textarea
                     v-model.lazy.trim="record.remarks"
                     placeholder="備註"
                     :rows="3"
                     :max-rows="6">
    			      </b-form-textarea>
              </b-input-group>
            </b-form>
	    </b-modal>

		<b-modal v-model="showOpenTimeEditModal" :title="openTimeEditTitle" :hide-footer="true" :hide-header="false">
			<b-card no-body>
			  <div slot="footer" class="col-xs-12 col-md-12 text-center">
				<b-button v-if="!openTimeEditProcessing" variant="primary" class="top-up-btn-sm" @click="OpenTimeEditConfirm()">{{$t('confirm')}}</b-button>
				<b-button v-else variant="primary" class="top-up-btn-sm">{{$t('processing')}}...</b-button>
			  </div>
			  <b-card-body class="container-fluid custom-padding">
				<div class="container-fluid custom-padding">
				  <div class="row">
					<div class="col">
					  <table class="table custom-table" style="font-size: 1rem; font-weight: bold;">
						<thead>
						  <tr>
							<th>{{$t('start_time')}}</th>
						  </tr>
						</thead>
						<tbody>
						  <tr>
							<td>
							  <VueCtkDateTimePicker
								v-if="showOpenTimeEditModal"
								ref="TimePickerStartTime"
								v-model="openTimeEditStartTime"
								style="font-size: 1.5rem; font-weight: bold;"
								:no-header="true" 
								:only-time="true" 
								:inline="true" 
								:format="'HH:mm'"
								:formatted="'HH:mm'"
								:no-label="true"
								:input-size="lg"
								:no-button-now="true"
								:noClearButton="true">
							  </VueCtkDateTimePicker>
							</td>
						  </tr>
						</tbody>
					  </table>
					</div>
					<div class="col">
					  <table class="table custom-table" style="font-size: 1rem; font-weight: bold;">
						<thead>
						  <tr>
							<th>{{$t('end_time')}}</th>
						  </tr>
						</thead>
						<tbody>
						  <tr>
							<td>
							  <VueCtkDateTimePicker
								v-if="showOpenTimeEditModal"
								ref="TimePickerEndTime"
								v-model="openTimeEditEndTime"
								style="font-size: 1.5rem; font-weight: bold;"
								:no-header="true" 
								:only-time="true" 
								:inline="true" 
								:format="'HH:mm'"
								:formatted="'HH:mm'"
								:no-label="true"
								:input-size="lg"
								:no-button-now="true"
								:noClearButton="true">
							  </VueCtkDateTimePicker>
							</td>
						  </tr>
						</tbody>
					  </table>
					</div>
				  </div>
				</div>
				<div>
				  <b-input-group class="d-flex p-2 bd-highlight custom-padding">
					<b-form-input v-model="WeeklyPickerInputValue" readonly></b-form-input> 
				  </b-input-group>
				</div>
				<div class="container-fluid custom-padding">
				  <div class="row">
					<div class="col custom-padding">
					  <table class="table custom-table-for-week">
						<thead>
						  <tr>
							<th>
							  <div class="device-list-clickable-text" :class="{'clicked': openTimeEditSelectedWeeks[1]}" @click="handleWeekClick(1)">{{$t('device.sun')}}</div>
							</th>
							<th> 
							  <div class="device-list-clickable-text" :class="{'clicked': openTimeEditSelectedWeeks[2]}" @click="handleWeekClick(2)">{{$t('device.mon')}}</div>
							</th>
							<th>
							  <div class="device-list-clickable-text" :class="{'clicked': openTimeEditSelectedWeeks[3]}" @click="handleWeekClick(3)">{{$t('device.tue')}}</div>
							</th>
							<th>
							  <div class="device-list-clickable-text" :class="{'clicked': openTimeEditSelectedWeeks[4]}" @click="handleWeekClick(4)">{{$t('device.wed')}}</div>
							</th>
							<th>
							  <div class="device-list-clickable-text" :class="{'clicked': openTimeEditSelectedWeeks[5]}" @click="handleWeekClick(5)">{{$t('device.thu')}}</div>
							</th>
							<th>
							  <div class="device-list-clickable-text" :class="{'clicked': openTimeEditSelectedWeeks[6]}" @click="handleWeekClick(6)">{{$t('device.fri')}}</div>
							</th>
							<th>
							  <div class="device-list-clickable-text" :class="{'clicked': openTimeEditSelectedWeeks[7]}" @click="handleWeekClick(7)">{{$t('device.sat')}}</div>
							</th>
						  </tr>
						</thead>
						<tbody>
						  
						</tbody>
					  </table>
					</div>
				  </div>
				</div>

				<div>
					<b-form-checkbox v-model="isChecked_HolidayClose" @change="HolidayCloseSwitch()" style="margin-top: 0px;" size="lg">國定假日不開放</b-form-checkbox>
				</div>
			  </b-card-body>
			</b-card>
		  </b-modal>
	</div>
</template>

<script>
import Vue from 'vue'
import {ServerTable, Event} from 'vue-tables-2'
import { required, minLength, between, email, minValue, integer } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import config from '@/config/global'
import notifications from '@/config/notifications'
import jQuery from 'jquery'
import select2 from 'select2'
// import qrcode from 'qrcode'
import sha1 from 'sha1'
import io from 'socket.io-client'
import _ from 'lodash'
import moment from 'moment-timezone'
import QRious from 'qrious'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

const encrypt    = config.encrypt;
const decrypt    = config.decrypt;
const admin_root = config.admin_root;
const api_root 	= config.api_root;
let $socket = null;

const clean_form = {
	name:         '',
	serialno:     '',
	meter_id:     '',
	brand:        '',
	floor:        '',
	end_user_id:  '',
	geo_location: '',
	remarks:      '',
	mqtt_pull:    '',
	mqtt_push:    '',
	lat: '',
	lng: '',
	billing_method: 'KWH',
	demo: 'NO',
	remoteable: 0,
	plug_and_charge: 0,
	rfid_charge: 0,
	schedulable: 0,
	idle_fee: 0,
	to_monit: 1,
	price: null,
	low_power_cutoff_threshold: 60,
	charging_timeout: 180,
	low_power_charging_timeout: 90,
	charging_time_limit_minutes: 2880,
	temperature_cutoff_celsius: 70
};

let $end_user_selec2    = null;
let $company_id_select2 = null;
let $brand_id_select2 = null;

Vue.use(ServerTable)

export default {
	name: 'device_list',
	notifications,
	components: {
		ServerTable,
		Event,
		Multiselect,
		vSelect,
		VueCtkDateTimePicker
	},
	data(){
		let app = this;
		let cannotEdit = app.$state.$get('ccff') === 'N/A' ? false : true;

		return {
			demo_options: [
				{label:'YES', value:'YES'},
				{label:'NO', value:'NO'}
			],
			billing_method_options: [
				{label:'KWH', value: 'KWH'},
				{label:'TIME', value: 'TIME'}
			],
			remoteable_options: [
				{label:'YES', value: 'YES'},
				{label:'NO', value: 'NO'}
			],
			plug_and_charge_options: [
				{label:'YES', value: 'YES'},
				{label:'NO', value: 'NO'}
			],
			rfid_charge_options: [
				{label:'YES', value: 'YES'},
				{label:'NO', value: 'NO'}
			],
			schedulable_options: [
				{label:'YES', value: 'YES'},
				{label:'NO', value: 'NO'}
			],
			idle_fee_options: [
				{label:'YES', value: 'YES'},
				{label:'NO', value: 'NO'}
			],
			to_monit_options: [
				{label:'YES', value: 'YES'},
				{label:'NO', value: 'NO'}
			],
			/*charge_first_options: [
			{text:'YES', value: 1},
			{text:'NO', value: 0}
			],*/
			edit_billing_method: 'KWH',
			edit_remoteable: 'NO',
			edit_plug_and_charge: 'NO',
			edit_rfid_charge: 'NO',
			edit_schedulable: 'NO',
			edit_idle_fee: 'NO',
			edit_to_monit: 'YES',
			isChecked_PORSCHE: false,
			isChecked_BMW: false,
			isChecked_HolidayClose: false,
			available_open_times:[],
			showOpenTimeEditModal: false,
			openTimeEditTitle: '',
			openTimeSelected: null,
			openTimeEditProcessing: false,
			openTimeEditWeekly: 0,
			openTimeEditStartTime: '12:30',
			openTimeEditEndTime: '12:30',
			WeeklyPickerInputValue: '',
			openTimeEditSelectedWeeks: {
				1: false,
				2: false,
				3: false,
				4: false,
				5: false,
				6: false,
				7: false, 
			},
			hide_demo_option: cannotEdit,
			cannotEdit,
			device_uri: '',
			showQrCode: false,
			showLogList: false,
			selected_row: null,
			isFindingLoading: false,
			editRowId: null,
			record: Object.assign({}, clean_form),
			showEditorModal: false,
			delRowShowModal: false,
			delRowId: 0,
			delRowMsg: '',
			columns: ['name', 'company_id', 'sn', 'end_user_id','geo_location', 'billing_method', 'schedulable', 'idle_fee', 'test', 'device_activated', 'remarks','created'],
			logcolumns: ['user_id', 'phone', 'start_time', 'stop_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'used_time_idle', 'price_idle', 'sub_total', 'created'],
			data: [],
			logdata:[],
			options: {
				debounce: 86400000, // 停止預設的即時搜尋
				headings: {
					name:  '名稱',
					company_id: '公司',
					sn:    '序號',
					end_user_id: '擁有者',
					test: '溫度',
					device_activated: '作動？',
					geo_location: '地理位置',
					billing_method: '計費方式',
					schedulable: '排程充電',
					idle_fee: '佔位收費',
					remarks: '備註',
					created: '最近作動時間'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['name', 'company_id', 'sn', 'end_user_id', 'brand_id', 'geo_location', 'device_activated', 'created'],
				filterable: ['name', 'sn', 'end_user_id', 'geo_location', 'device_activated'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let action = `${admin_root}/get_list/Device`;
					let params = {
						keyset: 'mqtt'
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = ''+data[col];
					}

					return fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						app.$nextTick(() => {
							app.set_mqtt_listen_list(result.data);
						});
						return {
							data: result.data || [],
							count: result.count || 0
						};
					}).catch(error => {
						app.$nextTick(() => {
							app.set_mqtt_listen_list([]);
						});
						return {
							data: [],
							count: 0
						};
					});
				}//eo requestFunction
			},
			logoptions: {
				headings: {
					// company_id: '公司',
					user_id: '使用者',
					phone: '電話',
					start_time: '起始時間',
					stop_time: '停止時間',
					end_time: '結束時間',
					status: '狀態',
					billing_method: '計費方式',
					interval: '時間',
					used_value: '使用(離峰/尖峰)',
					price: '單價(離峰/尖峰)',
					used_time_idle: '佔位時間',
					price_idle: '佔位單價',
					sub_total: '點數',
					created: '建立時間'
				},
				orderBy: {
					column: 'created',
					ascending: false
				},
				sortable: ['user_id', 'phone', 'start_time', 'end_time', 'status', 'interval', 'sub_total', 'created'],
				filterable: ['user_id', 'phone', 'start_time', 'end_time', 'status', 'interval', 'sub_total', 'created'],
				sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
				pagination: {
					chunk: 5,
					edge: false,
					nav: 'scroll'
				},
				perPage: 25,
				requestFunction(data) {
					let action = `${admin_root}/get_list/ChargingLog`;
					let params = {
					    keyset: 'mqtt',
					    queries: [
					    	{field: 'device_uid', value: app.target_device_id || ''}
					    ],
					};

					let ccff = this.$state.$get('ccff');
					if(ccff){
						params['ccff'] = ccff;
					}

					for(let col in data){
						params[col] = data[col];
					}
					params.skip_ccff = 1;

					return fetch(action, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify(params)
					}).then(res => res.json()).then(result => {
						//console.info('logdata result: ', result);
						app.$nextTick(() => {
							app.LogLoaded(result.data);
						});
						return {
						data: result.data || [],
						count: result.count || 0
						};
					}).catch(error => {
						app.$nextTick(() => {
							app.LogLoaded([]);
						});
						return {
						data: [],
						count: 0
						};
					});
				}//eo requestFunction
			},
			useVuex: false,
			theme: 'bootstrap4',
			template: 'default'
		};//eo return
	},//eo data

	mounted(){
		let app = this;

		// Search field 按下Enter後開始搜尋
		this.$nextTick(() => {
			let searchInput = document.querySelector('.VueTables__search-field input');
			if (searchInput) {
				// 取消 Vue Tables 內部的即時搜尋
				/*searchInput.addEventListener('input', (event) => {
					console.info('searchInput event:', event);
				}, true); // 捕獲模式，確保先執行*/

				// 監聽 Enter 鍵，才真正搜尋
				searchInput.addEventListener('keyup', (event) => {
					//console.info('keyup: ', event.key);
					//this.showSuccess({message:`key: ${event.key}`});
					if (event.key === "Enter" || event.key === "Go" || event.key === "Search") {
						this.$refs.dataTable.setFilter(searchInput.value);

						//強制清除 Vue Tables 內部的 debounce 計時器
						//this.$refs.dataTable.query = searchInput.value; // 直接覆寫內部值，避免 24 小時後觸發
					}
				});

				// 監聽 "失去焦點" (按 "下一步" 後，強制搜尋)
				searchInput.addEventListener('blur', () => {
					//console.info('blur event: 搜尋觸發');
					//this.showSuccess({message:'blur event: 搜尋觸發'});
					this.$refs.dataTable.setFilter(searchInput.value);
				});
			}
		});

		$socket = io(config.socket_entry, {transports: ['polling']});
		$socket.on('connect', () => {
			console.info('socket connected...');
		});

		$socket.on('mqtt_connected', (data) => {
			if(data.message.indexOf('&') !== -1){
				let parsed = config.mqtt_msg_parser(data.message);
				if(parsed && parsed.deviceid){
					if(parsed.tem > 0 && parsed.tem < 50) {
						jQuery('#THolder'+parsed.deviceid).html(`<span class="text-primary">${parsed.tem}°C</span>`)
					} else if(parsed.tem >= 50 && parsed.tem < 200) {
						jQuery('#THolder'+parsed.deviceid).html(`<span class="text-danger">${parsed.tem}°C</span>`)
					}
					jQuery('#PHolder'+parsed.deviceid).html('<span class="text-success"><i class=" fa fa-check"></i></span>')
				} else {
					jQuery('#PHolder'+parsed.deviceid).html('<span class="text-danger"><i class=" fa fa-times"></i></span>')
				}
			}
		});

		this.handler = function(records) {
			// console.info('vue-tables.loaded:', records);
			if(records.count){
				//collect device ids
				let device_ids = [];
				records.data.forEach((record, idx) => {
					if(record.id){
						device_ids.push(record.id);

						//clear connect status
						jQuery('#THolder' + record.sn).html('<span></span>')
						jQuery('#PHolder' + record.sn).html('<span><i class="fa fa-question-circle"></i></span>')
					}
				});

				if(device_ids.length){
					let skip = {};
					let action = `${config.mqtt_root}/get_latest_charging_record`;
					fetch(action, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify({
							user_id:   encodeURIComponent(app.$state.$get('adminuser').uuid),
							device_ids: device_ids,
							keyset: 'mqtt',
						})
					}).then(res => res.json()).then(charging_records => {
						// console.info('charging_records:', charging_records);
						if(charging_records.success){
							charging_records.records.forEach((record) => {
								let status = '';

								skip[record.device_uid] = 1;

								if(record.end_time && record.end_time>=record.start_time){
									// console.info(record.end_time);
									status = '<span class="text-warning">結束充電</span>（結束於'+moment.unix(record.end_time).tz(config.timezone).format('YYYY-MM-DD HH:mm')+'）';
								} else if(record.stop_time){
									status = '<span class="text-success">正在佔位</span>（起始於'+moment.unix(record.start_time).tz(config.timezone).format('YYYY-MM-DD HH:mm')+'）';
								} else if(record.start_time) {
									status = '<span class="text-info">正在充電</span>（起始於'+moment.unix(record.start_time).tz(config.timezone).format('YYYY-MM-DD HH:mm')+'）';
								} else {
									status = '尚未使用';
								}

								jQuery('#PCHolder' + record.device_uid).html(status);
							});
						}

						device_ids.forEach((device_id) => {
							if(skip[device_id]){
								return true;
							}
							jQuery('#PCHolder' + device_id).html('<span class="text-danger">暫無資料</span>');
						});
					}).catch(error => {
					});
				}
			}
		};
		Event.$on('vue-tables.loaded', this.handler);
	},
	
	beforeDestroy() {
		if ($socket) {
			$socket.disconnect();
			$socket = null;
		}
		Event.$off('vue-tables.loaded', this.handler);
	},
	
	methods: {
		logout(){
			let user_key = this.$route.path.indexOf('/dashboard/showdevice') !== -1 || this.$route.path.indexOf('/dashboard/history') !== -1 || this.$route.path.indexOf('/dashboard/transactions') !== -1 || this.$route.path.indexOf('/dashboard/members-setting') !== -1 || this.$route.path.indexOf('/dashboard/maps') !== -1 || this.$route.path.indexOf('/search/devices') !== -1 || this.$route.path.indexOf('/yushan') !== -1  ? 'user' : 'adminuser';
			let user_token = this.$state.$get(user_key);

			if(user_token){
			this.$state.$del(user_key);
			}

			if(this.$state.$get('adminuser')){
			this.$state.$del('adminuser'); 
			}

			if(this.$state.$get('uuid')){
			this.$state.$del('uuid'); 
			}

			if(this.$state.$get('keyword')){
			this.$state.$del('keyword'); 
			}

			if(this.$state.$get('ccff')){
			this.$state.$del('ccff'); 
			}

			if(this.$state.$get('device_id')){
			this.$state.$del('device_id'); 
			}

			let target = user_key === 'adminuser' ? '/_admin_' : '/';
			let ccid   = this.$state.$get('ccid');
			let href   = location.origin + `/#${target}`;

			if(this.$state.$get('ccid')){
			this.$state.$del('ccid'); 
			}

			if(ccid){
			href += '?' + jQuery.param({
				ccid
			});
			}

			// this.$router.push(target);
			window.location = href;
			// location.reload();
		},//eo logout

		get_used_value(row) {
			let used_value = '0.000/0.000度';
			if(row) {
				if(row.billing_method == 'TIME') {
					if((parseFloat(row.used_watts) + parseFloat(row.used_watts_peak)) > 0.2){
						used_value = Math.ceil(row.used_time/60) + '/' + Math.ceil(row.used_time_peak/60) + '分鐘' + '_' + row.used_watts + '/' + row.used_watts_peak + '度';
					} else {
						used_value = '0/0分鐘' + '_' + row.used_watts + '/' + row.used_watts_peak + '度';
					}
				} else {
					used_value = row.used_watts + '/' + row.used_watts_peak + '度';
				}
			}
			return used_value;
		},//eo get_used_value

		get_real_used_time_idle(row) {
			let [idle_free_period, idle_interval_rate, idle_max_price] = row.idle_info.split('/');
			let idle_free_period_sec = idle_free_period * 60;
			let idle_time = row.used_time_idle - idle_free_period_sec;
			if(idle_time <= 0) {
				idle_time = 0;
			}
			//console.info(Math.floor(idle_time / 60 ) + '分鐘');
			return Math.floor(idle_time / 60 ) + '分鐘';
		},

		editRow(row_id, row) {
			// console.info('edit row:', row);
			//row.charge_first = (row.charge_first === false || row.charge_first === undefined) ? 0 : 1;
      		//row.remoteable = (row.remoteable === false || row.remoteable === undefined) ? 'NO' : 'YES';
			this.edit_billing_method = (row.billing_method !== undefined) ? row.billing_method : 'KWH';
			this.edit_remoteable = (row.remoteable === false || row.remoteable === undefined) ? 'NO' : 'YES';
			this.edit_plug_and_charge = (row.plug_and_charge === false || row.plug_and_charge === undefined) ? 'NO' : 'YES';
			this.edit_rfid_charge = (row.rfid_charge === false || row.rfid_charge === undefined) ? 'NO' : 'YES';
			this.edit_schedulable = (row.schedulable === false || row.schedulable === undefined) ? 'NO' : 'YES';
			this.edit_idle_fee = (row.idle_fee === false || row.idle_fee === undefined) ? 'NO' : 'YES';
			this.edit_to_monit = (row.to_monit === false || row.to_monit === undefined) ? 'NO' : 'YES';
			
			this.isChecked_PORSCHE = row.support_car_brand.includes('PORSCHE') ? true : false;
			this.isChecked_BMW = row.support_car_brand.includes('BMW') ? true : false;

			this.selected_row = row;
			this.openEditor(row_id);

			this.selected_row['serialno'] = row['sn'];

			if(this.selected_row['end_user_id'] == 0){
				this.selected_row['end_user_id'] = '';
			}

			this.record = Object.assign({}, this.selected_row);
		},//eo editRow

		delRow(row_id, row_name) {
			// console.info('del row_id:', row_id);

			this.delRowShowModal = row_id ? true : false;
			this.delRowId        = row_id;
			this.delRowMsg       = `您確定要刪除${row_name}嗎？`;
		},//eo delRow

		submitDelRow(row_id) {
			let app    = this;
			let action = `${admin_root}/update_device`;
			let params = {
			    keyset: 'mqtt',
			    record: encodeURIComponent(encrypt(JSON.stringify({
			    	id: row_id,
			    	field: 'valid',
			    	value: 0,
			    	value_type: 'int'
			    })))
			};

			fetch(action, {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '資料更新成功',
						message: result.message
					});

					app.$refs['dataTable'].refresh();
				} else {
					app.showError({
						title: '資料更新失敗',
						message: result.message
					});
				}
			}).catch(error => {
				app.showError({
					title: '資料更新失敗',
					message: error
				});
			});
		},

		testRow(row_id) {
			console.info('test row_id:', row_id);
			this.showWarn({
				message: '開發中',
				title: '功能暫停'
			});
		},//eo testRow

		chkState(val) {
	      const field = this.$v.record[val];

	      // console.info('this.$v.record[val]:', this.$v.record[val], ', v:', field.value);

	      return !field.$dirty || !field.$invalid;
    	},

    	openEditor(row_id){
    		this.editRowId       = row_id;
    		this.showEditorModal = true;
    		this.$v.$reset();

    		let page_limit = 10;
    		let app        = this;

    		//workaround for select2 to be able to use search input
    		jQuery('div.modal-content').removeAttr('tabindex');

    		$company_id_select2 = jQuery('#device-company-id');

    		if($company_id_select2.length){
				//init select2
				$company_id_select2.select2({
					width: 'copy',
					dropdownAutoWidth: true,
					placeholder: '所屬公司...',
					allowClear: true,
					ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
						url: `${admin_root}/get_option_list/Company`,
						type: 'POST',
						dataType: 'json',
						quietMillis: 800 ,
						beforeSend: function (xhr) {
							xhr.setRequestHeader(
							"Authorization",
							"Bearer " + app.$state.$get('adminuser').token
							);
						},
						data: function (params) {
							let preselected_id = jQuery(this).val();
							return {
								preselected_id: preselected_id,
								query:          params.term, // search term
								page_limit:     page_limit,
								page:           params.page || 1
							};
						},
						results: function (data, page) {
							var more = (page * page_limit) < data.total;
							return {results: data.results, more: more};
						}
					},//eo ajax
				}).on('change', (event) => {
					app.record.company_id = $company_id_select2.select2('val');
				});
			}//eo $company_id_select2 init

			//workaround for Bootstrap4
			if($company_id_select2.data('select2')){
				$company_id_select2.data('select2').$container.addClass("form-control");
			}

			$end_user_selec2 = jQuery('#device-end_user_id');

			// console.info('$end_user_selec2:', $end_user_selec2);

			if($end_user_selec2.length){
				//init select2
				$end_user_selec2.select2({
					width: 'copy',
					dropdownAutoWidth: true,
					placeholder: '授權使用者...',
					allowClear: true,
					ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
						url: `${admin_root}/get_user_list`,
						type: 'POST',
						dataType: 'json',
						quietMillis: 800 ,
						beforeSend: function (xhr) {
							xhr.setRequestHeader(
							"Authorization",
							"Bearer " + app.$state.$get('adminuser').token
							);
						},
						data: function (params) {
							// console.info('term:', term, ', page:', page);
							let preselected_id = jQuery(this).val();
							return {
								preselected_id: preselected_id,
								query:          params.term, // search term
								page_limit:     page_limit,
								page:           params.page || 1,
								for_demo_only:  app.record.demo === 'YES' || (app.record.demo.value === 'YES') ? 1 : 0
							};
						},
						results: function (data, page) {
							var more = (page * page_limit) < data.total;
							return {results: data.results, more: more};
						}
					},//eo ajax
				}).on('change', (event) => {
					app.record.end_user_id = $end_user_selec2.select2('val');
				});
			}

			//workaround for Bootstrap4
			if($end_user_selec2.data('select2')){
				$end_user_selec2.data('select2').$container.addClass("form-control");
			}

			$brand_id_select2 = jQuery('#device-brand-id');

    		if($brand_id_select2.length){
				//init select2
				$brand_id_select2.select2({
					width: 'copy',
					dropdownAutoWidth: true,
					placeholder: '充電樁廠牌',
					allowClear: true,
					ajax: { // instead of writing the function to execute the request we use Select2's convenient helper
						url: `${admin_root}/get_option_list/ChargerBrand`,
						type: 'POST',
						dataType: 'json',
						quietMillis: 800 ,
						beforeSend: function (xhr) {
							xhr.setRequestHeader(
							"Authorization",
							"Bearer " + app.$state.$get('adminuser').token
							);
						},
						data: function (params) {
							let preselected_id = jQuery(this).val();
							return {
								preselected_id: preselected_id,
								query:          params.term, // search term
								page_limit:     page_limit,
								page:           params.page || 1
							};
						},
						results: function (data, page) {
							var more = (page * page_limit) < data.total;
							return {results: data.results, more: more};
						}
					},//eo ajax
				}).on('change', (event) => {
					app.record.brand_id = $brand_id_select2.select2('val');
				});
			}//eo $company_id_select2 init

			//workaround for Bootstrap4
			if($brand_id_select2.data('select2')){
				$brand_id_select2.data('select2').$container.addClass("form-control");
			}

			if(row_id && app.selected_row){
				let $option = jQuery('<option selected>讀取中...</option>').val(app.selected_row.end_user_id);
				// $end_user_selec2.val(app.selected_row.end_user_id).append($option).trigger('change');
				$end_user_selec2.val(app.selected_row.end_user_id).trigger('change');
				if(app.selected_row.end_user_id) {
					let action = `${admin_root}/get_user_list`;
					fetch(action, {
						method: 'POST',
						headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify({
							id: app.selected_row.end_user_id
						})
					}).then(res => res.json()).then(result => {
						if(result.results.length){
							let user = result.results.pop();
							$option.text(user.text).val(user.id);
							$option.removeData();

							$end_user_selec2.append($option);

							$end_user_selec2.trigger({
								type: 'select2:select',
								params: {
								data: user
								}
							});

							$end_user_selec2.val(user.id).trigger('change');
						} else {
							// $option.revmove();
							$end_user_selec2.val(null);
							app.showError({
								title: '系統錯誤',
								message: '無法讀取資料，請稍後再試'
							});
						}
					}).catch(error => {
						// $option.revmove();
						$end_user_selec2.val(null);
						app.showError({
							title: '系統錯誤',
							message: '無法讀取資料，請稍後再試'
						});
					});
				}
				
				let $option1 = jQuery('<option selected>讀取中...</option>').val(app.selected_row.company_id);
				$company_id_select2.val(app.selected_row.company_id).trigger('change');
				if(app.selected_row.company_id) {
					let action = `${admin_root}/get_option_list/Company`;
					fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify({
							id: app.selected_row.company_id
						})
					}).then(res => res.json()).then(result => {
						if(result.results.length){
							let rec = result.results.pop();
							$option1.text(rec.text).val(rec.id);
							$option1.removeData();

							$company_id_select2.html('');

							$company_id_select2.append($option1);

							$company_id_select2.trigger({
								type: 'select2:select',
								params: {
								data: rec
								}
							});

							$company_id_select2.val(rec.id).trigger('change');
						} else {
							// $option.revmove();
							$company_id_select2.val(null);
							app.showError({
								message: '無法讀取公司資料，請重新指定'
							});
						}
					}).catch(error => {
						// $option.revmove();
						$company_id_select2.val(null);
						app.showError({
							message: '無法讀取公司資料，請重新指定'
						});
					});
				}
				
				let $option2 = jQuery('<option selected>讀取中...</option>').val(app.selected_row.brand_id);
				$brand_id_select2.val(app.selected_row.brand_id).trigger('change');
				if(app.selected_row.brand_id) {
					let action = `${admin_root}/get_option_list/ChargerBrand`;
					fetch(action, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
						},
						body: JSON.stringify({
							id: app.selected_row.brand_id
						})
					}).then(res => res.json()).then(result => {
						if(result.results.length){
							let rec = result.results.pop();
							$option2.text(rec.text).val(rec.id);
							$option2.removeData();

							$brand_id_select2.html('');

							$brand_id_select2.append($option2);

							$brand_id_select2.trigger({
								type: 'select2:select',
								params: {
								data: rec
								}
							});

							$brand_id_select2.val(rec.id).trigger('change');
						} else {
							// $option.revmove();
							$brand_id_select2.val(null);
							app.showError({
								message: '無法讀取廠牌，請重新指定'
							});
						}
					}).catch(error => {
						// $option.revmove();
						$brand_id_select2.val(null);
						app.showError({
							message: '無法讀取廠牌，請重新指定'
						});
					});
				}

				let action = `${admin_root}/get_open_times`;
				let params = {
					deviceid: row_id
				};

				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + app.$state.$get('adminuser').token
					},
					body: JSON.stringify(params)
				}).then(res => res.json()).then(result => {
					app.available_open_times = [];
					if(result.success){
						//console.info('result: ', JSON.stringify(result));
						let open_times = result.open_times;
						if(open_times && open_times.count > 0) {
							app.available_open_times = open_times.rows;
							app.available_open_times.forEach((open_time, index) => {
								open_time.start_time = open_time.start_time.substring(0, 5);
								open_time.end_time = open_time.end_time.substring(0, 5);    
							});
							//console.info('available_open_times : ', JSON.stringify(app.available_open_times));
						}	
					}
				}).catch(error => {
					app.available_open_times = [];
				});
			} else {
				app.record       = Object.assign({}, clean_form);
				app.edit_billing_method = 'KWH';
				app.edit_remoteable = 'NO';
				app.edit_plug_and_charge = 'NO';
				app.edit_rfid_charge = 'NO';
				app.edit_schedulable = 'NO';
				app.edit_idle_fee = 'NO';
				app.edit_to_monit = 'YES';
				
				app.isChecked_PORSCHE = false;
				app.isChecked_BMW = false;
				app.selected_row = null;
				app.row_id       = null;
				app.available_open_times = [];

				$company_id_select2.val('').trigger('change');	
				$end_user_selec2.val('').trigger('change');	
				$brand_id_select2.val('').trigger('change');	
			}
    	},

		SysReboot(sn) {
			let app = this;
			let msg = '';
			msg = `您確定要重開${sn}嗎？`;
			if (window.confirm(msg)) {
				let action = `${admin_root}/sys_reboot`;
				let params = {
					keyset: 'mqtt'
				};

				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify(params)
				}).then(res => res.json()).then(result => {
					if(result.success){
						app.showSuccess({
							title: '裝置重啟',
							message: '裝置重啟中...'
						});
						app.logout();
					} else {
						app.showError({
							title: '裝置重啟失敗',
							message: '裝置重啟失敗，請稍後再試'
						});
					}
				}).catch(error => {
					app.showError({
						title: '裝置重啟失敗',
						message: '裝置重啟失敗，請稍後再試'
					});
				});
			}
		},

		DevReboot(target_sn) {
			let app = this;
			let msg = '';
			msg = `您確定要重開${target_sn}嗎？`;
			if (window.confirm(msg)) {
				let sn = encodeURIComponent(config.encrypt(target_sn, config.ffkey, config.ffiv));
				let action = `${config.api_root}/dev_reboot`;
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						keyset: 'mqtt',
						sn: sn
					})
				}).then(res => res.json()).then(result => {
					if(result.success){
						app.showSuccess({
							title: '裝置重啟',
							message: result.message ? result.message : '裝置重啟成功'
						});
					} else {
						app.showError({
							title: '裝置重啟',
							message: result.message ? result.message : '裝置重啟失敗，請稍後再試'
						});
					}
				}).catch(err => {
					app.showError({
						title: '裝置重啟',
						message: result.message ? result.message : '裝置重啟失敗，請稍後再試'
					});
				});
			}
		},

		meter_id_format_check(meter_id){
			if(meter_id == null || meter_id == '') {
				return true;
			}
			return /^[^_]+_[^_]+$/.test(meter_id);
		},

    	submitRecord(event) {

    		let app    = this;
    		let row_id = app.editRowId;

    		this.$v.$touch();

		    if (this.$v.$invalid) {
		        this.showError({message:'請輸入必填欄位', title:'資料錯誤'});
		        return false;
		    }
            
            if(!this.cannotEdit && this.record.demo.value !== undefined &&this.record.demo.value === 'YES' && !this.record.end_user_id){
                this.showError({message:'DEMO裝置必須指派擁有人'});
		        return false;
            }

			if(this.meter_id_format_check(this.record.meter_id) == false){
				this.showError({message:'meter_id格式錯誤', title:'格式錯誤'});
				return false;
			}

			if(this.record.meter_id == '') {
				this.record.meter_id = null;
			}

			if(this.record.floor == '') {
				this.record.floor = null;
			}

			if(this.edit_billing_method && this.edit_billing_method.value !== undefined){
                this.record.billing_method = this.edit_billing_method.value;
            }
            
            if(this.record.demo && this.record.demo.value !== undefined){
                this.record.demo = this.record.demo.value;
            }

			if(this.edit_remoteable && this.edit_remoteable.value !== undefined){
                this.record.remoteable = this.edit_remoteable.value === 'YES' ? 1 : 0;
            }

			if(this.edit_plug_and_charge && this.edit_plug_and_charge.value !== undefined){
                this.record.plug_and_charge = this.edit_plug_and_charge.value === 'YES' ? 1 : 0;
            }

			if(this.edit_rfid_charge && this.edit_rfid_charge.value !== undefined){
                this.record.rfid_charge = this.edit_rfid_charge.value === 'YES' ? 1 : 0;
            }

			if(this.edit_schedulable && this.edit_schedulable.value !== undefined){
                this.record.schedulable = this.edit_schedulable.value === 'YES' ? 1 : 0;
            }

			if(this.edit_idle_fee && this.edit_idle_fee.value !== undefined){
                this.record.idle_fee = this.edit_idle_fee.value === 'YES' ? 1 : 0;
            }

			if(this.edit_to_monit && this.edit_to_monit.value !== undefined){
                this.record.to_monit = this.edit_to_monit.value === 'YES' ? 1 : 0;
            }

			this.record.support_car_brand = "";
			if(this.isChecked_PORSCHE){
                this.record.support_car_brand += 'PORSCHE';
            }
			if(this.isChecked_BMW){
				if(this.record.support_car_brand.length > 0){
					this.record.support_car_brand += '/';
				}
                this.record.support_car_brand += 'BMW';
            }

		    let to_save = this.record;

		    if(row_id){
		    	to_save['id'] = row_id;
		    }

        	/*if (to_save['charge_first'] && to_save['charge_first']['value'] !== undefined) {
          		to_save['charge_first'] = to_save['charge_first']['value'];
        	}*/

			to_save = encodeURIComponent(encrypt(JSON.stringify(to_save)));

			let open_times = this.available_open_times;
			open_times = encodeURIComponent(encrypt(JSON.stringify(open_times)));

			let action = `${admin_root}/save_device`;
			let params = {
				keyset: 'mqtt',
				record: to_save,
				open_times: open_times
			};

			fetch(action, {
				method: 'POST',
				headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
				},
				body: JSON.stringify(params)
			}).then(res => res.json()).then(result => {
				if(result.success){
					app.showSuccess({
						title: '成功',
						message: '資料成功儲存'
					});
					app.$refs['dataTable'].refresh();
					app.record = Object.assign({}, clean_form);
					app.$v.$reset();
				} else {
					if (event) {
						event.preventDefault();
					}
					app.showError({
						title: '錯誤',
						message: '無法儲存資料，請稍後再試'
					});
					app.$refs['dataTable'].refresh();
				}
			}).catch(error => {
				if (event) {
					event.preventDefault();
				}
				app.showError({
					title: '錯誤',
					message: '無法儲存資料，請稍後再試'
				});
				app.$refs['dataTable'].refresh();
			});
		},
		
		genRow(row_id) {
			// console.info('row clicked: ', row_id);
			this.showQrCode = true;
			row_id          = encodeURIComponent(config.encrypt(row_id, config.ffkey, config.ffiv));
			let msg = `${config.frontend}?uuid=${row_id}`;
			// console.info('msg:', msg);
			(new QRious({
				element: document.getElementById('qrcode-canvas'),
				value: msg,
				size: 160
			}));
			this.device_uri = `${config.frontend}?uuid=${row_id}`;
		},//eo onRowClick
		openLog(row){
			let app = this;
			app.target_device_id = row.id;
			app.showLogList = true;
			this.logcolumns = ['user_id', 'phone', 'start_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'sub_total', 'created'];
			app.$refs['logDataTable'].refresh();
		},
		LogLoaded(datas){
			//console.info('datas:', datas);
			let have_idle_fee = datas.find(data => data.used_time_idle > 0);
			if(have_idle_fee) {
				this.logcolumns = ['user_id', 'phone', 'start_time', 'stop_time', 'end_time', 'status', 'billing_method', 'interval', 'used_value', 'price', 'used_time_idle', 'price_idle', 'sub_total', 'created'];
			}
		},
		set_mqtt_listen_list(datas){
			let device_ids = [];
			datas.forEach((data, idx) => {
				device_ids.push(data.sn);
			});
			//console.info('device_ids:', device_ids);
			$socket.emit('mqtt_socket', {
				type: 'mqtt-listen-list',
				token: this.$state.$get('adminuser').token,
				device_ids: device_ids
			});
		},
		getWeeklyInfo(weekly){
			let info = '';
			if(weekly) {
				if(weekly == 127) {
					info = this.$t('device.everyday');
				} else {
					//show weekly info
					let sun = weekly & 64;
					let mon = weekly & 32;
					let tue = weekly & 16;
					let wed = weekly & 8;
					let thu = weekly & 4;
					let fri = weekly & 2;
					let sat = weekly & 1;

					info = this.$t('device.every') + ' ';
					if(sun) {
						info += this.$t('device.week_sun') + ' ';
					}
					if(mon) {
						info += this.$t('device.week_mon') + ' ';
					}
					if(tue) {
						info += this.$t('device.week_tue') + ' ';
					}
					if(wed) {
						info += this.$t('device.week_wed') + ' ';
					}
					if(thu) {
						info += this.$t('device.week_thu') + ' ';
					}
					if(fri) {
						info += this.$t('device.week_fri') + ' ';
					}
					if(sat) {
						info += this.$t('device.week_sat') + ' ';
					}
				}
			}
			return info;
		},
		openTimeEditSelectedWeeksClear(){
			this.openTimeEditWeekly = 0;
			this.$set(this.openTimeEditSelectedWeeks, 1, false);
			this.$set(this.openTimeEditSelectedWeeks, 2, false);
			this.$set(this.openTimeEditSelectedWeeks, 3, false);
			this.$set(this.openTimeEditSelectedWeeks, 4, false);
			this.$set(this.openTimeEditSelectedWeeks, 5, false);
			this.$set(this.openTimeEditSelectedWeeks, 6, false);
			this.$set(this.openTimeEditSelectedWeeks, 7, false);
		},
		HolidayCloseSwitch(){
			this.isChecked_HolidayClose = !this.isChecked_HolidayClose;
		},
		handleWeekClick(id) {
			this.$set(this.openTimeEditSelectedWeeks, id, !this.openTimeEditSelectedWeeks[id]);

			this.openTimeEditWeekly = 0;
			this.openTimeEditWeekly += this.openTimeEditSelectedWeeks[1] === true ? 64 : 0;
			this.openTimeEditWeekly += this.openTimeEditSelectedWeeks[2] === true ? 32 : 0;
			this.openTimeEditWeekly += this.openTimeEditSelectedWeeks[3] === true ? 16 : 0;
			this.openTimeEditWeekly += this.openTimeEditSelectedWeeks[4] === true ? 8 : 0;
			this.openTimeEditWeekly += this.openTimeEditSelectedWeeks[5] === true ? 4 : 0;
			this.openTimeEditWeekly += this.openTimeEditSelectedWeeks[6] === true ? 2 : 0;
			this.openTimeEditWeekly += this.openTimeEditSelectedWeeks[7] === true ? 1 : 0;

			this.WeeklyPickerInputValue = this.getWeeklyInfo(this.openTimeEditWeekly);
		},
		popOpenTimeEditModal(open_time) {
			this.showOpenTimeEditModal = true;
			this.openTimeEditProcessing = false;
			this.isChecked_HolidayClose = false;
			this.openTimeSelected = open_time;
			this.openTimeEditStartTime = '12:30'; //Add this to fixed time select not focus on middle.
			this.openTimeEditEndTime = '12:30'; //Add this to fixed time select not focus on middle.

			if(open_time) {
				this.openTimeEditTitle = "修改排程充電";

				this.openTimeEditWeekly = open_time.weekly;
				this.isChecked_HolidayClose = open_time.holiday_close;
				//console.log('scheduleEditWeekly:' , this.scheduleEditWeekly);
				this.$set(this.openTimeEditSelectedWeeks, 1, (this.openTimeEditWeekly & 64) > 0 ? true : false);
				this.$set(this.openTimeEditSelectedWeeks, 2, (this.openTimeEditWeekly & 32) > 0 ? true : false);
				this.$set(this.openTimeEditSelectedWeeks, 3, (this.openTimeEditWeekly & 16) > 0 ? true : false);
				this.$set(this.openTimeEditSelectedWeeks, 4, (this.openTimeEditWeekly & 8) > 0 ? true : false);
				this.$set(this.openTimeEditSelectedWeeks, 5, (this.openTimeEditWeekly & 4) > 0 ? true : false);
				this.$set(this.openTimeEditSelectedWeeks, 6, (this.openTimeEditWeekly & 2) > 0 ? true : false);
				this.$set(this.openTimeEditSelectedWeeks, 7, (this.openTimeEditWeekly & 1) > 0 ? true : false);
				
				this.$nextTick(() => { //Add $nextTick to fixed time select not focus on middle.
					this.openTimeEditStartTime = open_time.start_time;
					this.openTimeEditEndTime = open_time.end_time;
				}); 
			} else {
				this.openTimeEditTitle = "新增排程充電";

				this.openTimeEditSelectedWeeksClear();

				this.$nextTick(() => { //Add $nextTick to fixed time select not focus on middle.
					this.openTimeEditStartTime = '00:00';
					this.openTimeEditEndTime = '00:00';
				});
			}
			this.WeeklyPickerInputValue = this.getWeeklyInfo(this.openTimeEditWeekly);
		}, // eo popScheduleEditModal
		OpenTimeEditConfirm(){
			let app = this;
			let row_id = this.editRowId;
			if(this.openTimeSelected) {
				this.openTimeSelected.start_time = this.openTimeEditStartTime;
				this.openTimeSelected.end_time = this.openTimeEditEndTime;
				this.openTimeSelected.weekly = this.openTimeEditWeekly;
				this.openTimeSelected.holiday_close = this.isChecked_HolidayClose;
			} else {
				let new_open_time = {
					device_id: row_id,
					weekly: this.openTimeEditWeekly,
					start_time: this.openTimeEditStartTime,
					end_time: this.openTimeEditEndTime,
					holiday_close: this.isChecked_HolidayClose,
				}
				this.available_open_times.push(new_open_time);
			}
			//console.info('Update available_open_times : ', JSON.stringify(this.available_open_times));
			this.showOpenTimeEditModal = false;
		},
		OpenTimeRemove(open_time){
			let msg = '';
			if(open_time) {
				msg = "是否刪除此設定?"
				if (window.confirm(msg)) {
					let index = this.available_open_times.indexOf(open_time);
					if(index !== -1) {
						if(open_time.id) {
							open_time.delete = 1; //mark this open_time to delete.
							this.$set(this.available_open_times, index, open_time);//add this to fixed available_open_times not refresh.
						} else {
							this.available_open_times.splice(index, 1); //remove this open_time.
						}
					}
					//console.info('Removed available_open_times : ', JSON.stringify(this.available_open_times));
				}
			}
		},
		isCharging(id) {
			const el = document.getElementById('PCHolder' + id);
			if (!el) return false;
			return (el.innerText.includes('正在充電') || el.innerText.includes('正在佔位'));
		},
		forceCheckout(target_sn) {
			let app = this;
			let msg = '';
			msg = `您確定要強制結帳${target_sn}嗎？`;
			if (window.confirm(msg)) {
				let sn = encodeURIComponent(config.encrypt(target_sn, config.ffkey, config.ffiv));
				let action = `${config.mqtt_root}/force_checkout`;
				fetch(action, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + this.$state.$get('adminuser').token
					},
					body: JSON.stringify({
						keyset: 'mqtt',
						device_id: sn
					})
				}).then(res => res.json()).then(result => {
					if(result.success){
						app.showSuccess({
							title: '成功',
							message: '強制結帳成功'
						});
					} else {
						app.showError({
							title: '錯誤',
							message: result.message
						});
					}
				}).catch(err => {
					let err_msg = '';
					// 如果 error 是物件，優先用 message 屬性
					if (error && typeof error === 'object') {
						err_msg = error.message || JSON.stringify(error);
					} else {
						err_msg = error; // 文字型態直接用
					}
					app.showError({
						title: '錯誤',
						message: err_msg
					});
				});
			}
		},//eo onRowClick
	},//eo methods

	validations: {
		record: {
			name: {
				required,
				minLength: minLength(2)
			},
			serialno: {
				required,
				minLength: minLength(4),
			},
			meter_id: {
				validFormat(value) {
					if (value == null || value === '') return true;
					return /^[^_]+_[^_]+$/.test(value);
				}
			},
			end_user_id: {
				required: false,
				integer,
				// minValue: minValue(1)
			},
			company_id: {
				required: false,
				integer
				// minLength: minLength(1)
			},
			brand_id: {
				required: false,
				integer
			},
			price: {
				required: false,
			}
		}
	},//eo validations
	
};
</script>
<style lang="scss">
.card-body{padding:0;}
.checkbox-container {display: flex;}
.checkbox-container .custom-checkbox {margin-right: 10px;}
.add-btn{}
.help-text{margin-top: 0.5rem; margin-left: 0.8rem;}
.multiselect__input{width:100%;border:none;}
#qrcode-canvas{
	display:inline-block;
	margin: auto;
}
#dataTable {
	width: 95%;
	margin: 0 auto;
	margin-top: 0.5rem;
	font-size: 0.75rem;

	.VuePagination {
	  text-align: center;
	  justify-content: center;
	}

	.vue-title {
	  text-align: center ;
	  margin-bottom: 10px;
	}

	.VueTables__search-field {
	  display: flex;
	}
	.VueTables__search-field input {
	  margin-left: 0.25rem;
	}

	.VueTables__limit-field {
	  display: flex;
	}

	.VueTables__limit-field select {
	  margin-left: 0.25rem !important;
	}

	.VueTables__table th {
	  text-align: center;
	}

	.VueTables__child-row-toggler {
	  width: 16px;
	  height: 16px;
	  line-height: 16px;
	  display: block;
	  margin: auto;
	  text-align: center;
	}

	.VueTables__child-row-toggler--closed::before {
	  content: "+";
	}

	.VueTables__child-row-toggler--open::before {
	  content: "-";
	}

	.VueTables__sortable {
		padding: 0.25rem;
	}
}
.modal .modal-xl {
	max-width: 90% !important;
    width: 90% !important;
}
.custom-table th,
.custom-table td {
	text-align: center;
	vertical-align: middle;
	padding: 1px;
}
.custom-table-for-week th,
.custom-table-for-week td {
	text-align: center;
	vertical-align: middle;
	padding: 1px;
}
.device-list-clickable-text {
	cursor: pointer;
	transition: background-color 0.3s, color 0.3s;
	color: black !important;
	text-decoration: none !important;
}
.device-list-clickable-text.clicked {
	background-color: #007bff;
	color: white !important;
}
.top-up-btn-sm{
	height: 3rem;
	max-width: 98%;
	min-width: 98%;
	margin: 0.5px 0px;
}
.custom-padding {
	padding: 0px;
}

</style>
